import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { UserExperienceConfirmationModalComponent } from 'src/app/shared/components/user-experience-confirmation-modal/user-experience-confirmation-modal.component';
import { FeedbackType } from 'src/app/shared/enums/user-app-experience.enum';
import { UserFeedbackService } from 'src/app/shared/services/user.feedback.service';

@Component({
  selector: 'app-user-experience-improvement-feedback-modal',
  templateUrl: './user-experience-improvement-feedback-modal.component.html',
  styleUrls: ['./user-experience-improvement-feedback-modal.component.scss'],
})
export class UserExperienceImprovementFeedbackModalComponent {
  readonly messageMaxLengthLimit: number = 1500;

  feedbackForm: FormGroup = new FormGroup({
    message: new FormControl('', [
      Validators.required,
      Validators.maxLength(this.messageMaxLengthLimit),
      Validators.minLength(25),
    ]),
  });

  isSubmitted = false;

  constructor(
    private modalCtrl: ModalController,
    private userFeedbackService: UserFeedbackService,
  ) {}

  sendFeedback(): void {
    this.isSubmitted = true;
    if (this.feedbackForm.valid && this.feedbackForm.value.message.trim()) {
      this.storeFeedback(this.feedbackForm.value.message.trim());
    }
  }

  /**
   *
   * @param feedback - of user want to send to mable.
   */
  async storeFeedback(feedback?: string): Promise<void> {
    try {
      await this.userFeedbackService.storeUserFeedback({
        attributes: {
          response: FeedbackType.NEGATIVE,
          feedback,
        },
      });

      if (feedback) {
        this.modalCtrl
          .create({
            component: UserExperienceConfirmationModalComponent,
          })
          .then(async (modal) => {
            await modal.present();
            modal.onDidDismiss().then(() => {
              this.modalCtrl.dismiss();
            });
          });
      } else {
        this.modalCtrl.dismiss();
      }
    } catch (error) {
      // suppressing error
      console.error('[Failed to store user feedback]', error);
      this.modalCtrl.dismiss();
    }
  }

  async dismiss(): Promise<void> {
    this.storeFeedback();
  }
}
